// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ContactSearch } from '@/contact/components/contact-search';
import { SparseCustomer } from '@/sparse/api/types';
import {
  Control,
  FieldValues,
  UseControllerProps,
  useController,
} from 'react-hook-form';

interface Props<Values extends FieldValues> extends UseControllerProps<Values> {
  label: string;
  control: Control<Values>;
  disabled?: boolean;
  priorityCustomerId?: string;
  defaultCustomer?: SparseCustomer | null;
  size?: 'small' | 'medium';
}

export function FormContactSearch<Values extends FieldValues>(
  props: Props<Values>
) {
  const { field, fieldState } = useController({
    name: props.name,
    control: props.control,
  });

  return (
    <ContactSearch
      ref={field.ref}
      name={field.name}
      label={props.label}
      value={field.value ?? null}
      disabled={props.disabled}
      priorityCustomerId={props.priorityCustomerId}
      defaultCustomer={props.defaultCustomer}
      size={props.size}
      onChange={(value) => {
        field.onChange(value);
      }}
      error={Boolean(fieldState.error)}
      helperText={fieldState.error?.message}
    />
  );
}
